/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateAddNodeClientIdMax = 36;

export const mutateAddNodeClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateAddNodeContentTypeClientIdMax = 36;

export const mutateAddNodeContentTypeClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const mutateAddNodeTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const mutateAddNodeTypeDefinitionReferenceViewPredicatesMax = 10;

export const mutateAddNodeTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const mutateAddNodeTypeDefinitionReferenceViewSearchTermsMax = 10;

export const mutateAddNodeTypeNameMax = 200;

export const MutateAddNode = zod.object({
  clientId: zod
    .string()
    .min(1)
    .max(mutateAddNodeClientIdMax)
    .regex(mutateAddNodeClientIdRegExp)
    .describe(
      'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
    ),
  contentTypeClientId: zod
    .string()
    .min(1)
    .max(mutateAddNodeContentTypeClientIdMax)
    .regex(mutateAddNodeContentTypeClientIdRegExp)
    .optional()
    .describe(
      'An INSTANCE’s TYPE added in THIS request. XOR with `contentTypeUuid`. Not accepted on a TYPE node.',
    ),
  contentTypeUuid: zod
    .uuid()
    .optional()
    .describe(
      'For an INSTANCE, the TYPE it instantiates (XOR with `contentTypeClientId`). For a TYPE, an optional grouping parent — which must already exist.',
    ),
  occurredAt: zod.iso.datetime({ offset: true }).optional(),
  subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
  typeDefinition: zod
    .object({
      conformance: zod
        .enum(['open', 'lax', 'strict'])
        .optional()
        .describe(
          'open enforces slots and allows extra bodies; strict additionally rejects extra bodies; lax admits slot violations and reports them in audit. Omission preserves the stored declaration; null cannot clear it.',
        ),
      description: zod.string().nullish(),
      enums: zod
        .array(
          zod.object({
            label: zod.string(),
            value: zod.string(),
          }),
        )
        .nullish()
        .describe(
          'Ordered ENUM choices as { value, label } pairs. Both are preserved; this contract does not collapse a label into its value.',
        ),
      file: zod
        .object({
          allowedFormats: zod
            .array(
              zod.enum([
                'pdf',
                'doc',
                'docx',
                'xls',
                'xlsx',
                'csv',
                'txt',
                'jpeg',
                'png',
                'webp',
                'gif',
                'heic',
                'md',
                'html',
                'mp3',
                'm4a',
                'wav',
                'mp4',
                'mov',
                'webm',
              ]),
            )
            .min(1)
            .optional(),
        })
        .nullish(),
      metadata: zod
        .record(zod.string(), zod.unknown())
        .nullish()
        .describe(
          'Arbitrary authored metadata. Its keys are content, not command fields, and are stored and returned unaltered.',
        ),
      reference: zod
        .object({
          carbonCopy: zod.boolean().optional(),
          creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
          edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
          typeLineageUuid: zod.uuid(),
          typeUuid: zod.uuid(),
          view: zod
            .object({
              predicates: zod
                .array(
                  zod.object({
                    op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                    pathTypeUuids: zod
                      .array(zod.uuid())
                      .min(1)
                      .max(mutateAddNodeTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax),
                    value: zod.string().optional(),
                    valueType: zod
                      .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                      .optional(),
                  }),
                )
                .max(mutateAddNodeTypeDefinitionReferenceViewPredicatesMax)
                .optional(),
              searchTerms: zod
                .array(
                  zod
                    .string()
                    .min(1)
                    .max(mutateAddNodeTypeDefinitionReferenceViewSearchTermsItemMax),
                )
                .max(mutateAddNodeTypeDefinitionReferenceViewSearchTermsMax)
                .optional(),
            })
            .nullish(),
        })
        .nullish(),
      signature: zod.looseObject({}).nullish(),
    })
    .optional(),
  typeName: zod
    .string()
    .min(1)
    .max(mutateAddNodeTypeNameMax)
    .optional()
    .describe('Required for variant TYPE; rejected for INSTANCE.'),
  value: zod
    .object({
      booleanValue: zod.boolean().nullish(),
      dateValue: zod.string().nullish(),
      datetimeValue: zod.string().nullish(),
      jsonValue: zod.unknown().optional(),
      numericValue: zod.number().nullish(),
      stringValue: zod.string().nullish(),
    })
    .optional(),
  valueType: zod
    .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME', 'ENUM', 'JSON'])
    .optional(),
  variant: zod
    .enum(['TYPE', 'INSTANCE'])
    .describe('Explicit, never inferred. A TYPE authors schema; an INSTANCE holds authored data.'),
});

export type MutateAddNode = zod.input<typeof MutateAddNode>;
export type MutateAddNodeOutput = zod.output<typeof MutateAddNode>;
